import {
  Button,
  ButtonGroup,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Modal,
  Typography,
  styled,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import ValueCalculator from "../ValueCalculator";
import Swipper from "../Swipper";

interface IRoller {
  id: number;
  img?: string;
  name: string;
  size: string;
  brand: string;
  price: number;
}

const TypographyCentered = styled(Typography)`
    align: center;
  `;


const Roller: React.FC<IRoller> = ({ img, name, size, brand, price }) => {
  const { t } = useTranslation();
  const images = img?.length ? img?.split(",").map((path) => { return `Rollers/${path.trim()}` }) : ["NoImage.jpg"];
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(0);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    (async () => {
      const dolarPrice: number = await ValueCalculator(price);
      setValue(dolarPrice as number)
    })()
  });

  return (
    <>
      <Card sx={{ maxWidth: 345 }}>
        <CardMedia
          key={images[0]}
          sx={{
            padding: "1em 1em 0 1em",
            objectFit: "contain"
          }}
          component="img"
          height={240}
          width={345}
          title="roller"
          image={require(`../../Assets/${images[0].trim()}`)}
          onClick={handleOpen}
          loading="lazy"
        ></CardMedia>
        <CardContent>
          <Typography gutterBottom variant="h5" component="p" align="center">
            {name}
          </Typography>
          <TypographyCentered>{brand}</TypographyCentered>
          <TypographyCentered>{size}</TypographyCentered>
        </CardContent>
        <CardActions>
          <ButtonGroup orientation="vertical" fullWidth>
            <TypographyCentered variant="subtitle1" border={2}>
              ${value}
            </TypographyCentered>
            <Button variant="contained" size="small" onClick={() => window.open(`https://wa.me/5493513901837?text=${encodeURIComponent(`${t("common.buy_message")}: \nRoller ${name} - ${size}mm - $${value}`)}&attachment=${encodeURIComponent(`Rollers/${images[0].trim()}`)}`)}>
              {t("common.buy")}
            </Button>
          </ButtonGroup>
        </CardActions>
      </Card>
      <Modal open={open}>
        <>
          <Swipper images={images} size={{ height: "550vw", width: "100vw" }} onImageClick={() => { return null; }} close={handleClose}></Swipper>
        </>
      </Modal>
    </>
  );
};

export type { IRoller };
export default React.memo(Roller);